import { useEffect, useState } from "react";
import { useLang } from "./LanguageContext";

const rnd = () => String(Math.floor(Math.random() * 10));
const labelCopy = {
  en: { labels: ["Days", "Hours", "Mins"], cta: "By invitation only" },
  it: { labels: ["Giorni", "Ore", "Min"], cta: "Solo su invito" },
  ru: { labels: ["Дней", "Часов", "Мин"], cta: "Только по приглашению" },
  es: { labels: ["Días", "Horas", "Min"], cta: "Solo con invitación" },
};

const styles = {
  light: {
    box: "border-ink/10 bg-surface/60 hover:border-terracotta/50 hover:bg-surface/80",
    num: "text-ink",
    label: "text-ink-soft",
    colon: "text-terracotta/60",
    divider: "border-ink/10",
    cta: "text-ink-soft group-hover:text-terracotta",
  },
  dark: {
    box: "border-bg/15 bg-bg/5 hover:border-terracotta/60 hover:bg-bg/10",
    num: "text-bg",
    label: "text-bg/50",
    colon: "text-terracotta",
    divider: "border-bg/15",
    cta: "text-bg/60 group-hover:text-terracotta",
  },
};

export const MysteryCountdown = ({ variant = "light" }) => {
  const [d, setD] = useState(["??", "??", "??"]);
  const s = styles[variant];
  const { lang } = useLang();
  const { labels, cta } = labelCopy[lang];

  useEffect(() => {
    const id = setInterval(() => {
      const i = Math.floor(Math.random() * 3);
      const scrambled = rnd() + rnd();
      setD((prev) => prev.map((v, idx) => (idx === i ? scrambled : v)));
      setTimeout(
        () => setD((prev) => prev.map((v, idx) => (idx === i ? "??" : v))),
        450
      );
    }, 1500);
    return () => clearInterval(id);
  }, []);

  return (
    <button
      type="button"
      onClick={() => document.getElementById("book")?.scrollIntoView({ behavior: "smooth" })}
      data-testid="mystery-countdown"
      aria-label="Request a private presentation"
      className={`group inline-flex items-center gap-2 md:gap-4 rounded-sm border backdrop-blur px-4 md:px-5 py-3 transition-colors duration-300 cursor-pointer text-left ${s.box}`}
    >
      {d.map((v, i) => (
        <div key={i} className="flex items-center gap-2 md:gap-4">
          <div className="text-center min-w-[2.2ch]">
            <div className={`font-serif text-2xl md:text-4xl tabular-nums leading-none tracking-widest ${s.num}`}>
              {v}
            </div>
            <div className={`text-[9px] uppercase tracking-[0.25em] mt-1.5 ${s.label}`}>
              {labels[i]}
            </div>
          </div>
          {i < 2 && (
            <span className={`font-serif text-2xl md:text-3xl -mt-3 ${s.colon}`}>:</span>
          )}
        </div>
      ))}
      <span className={`hidden sm:flex ml-1 md:ml-2 items-center gap-2 pl-3 md:pl-4 border-l ${s.divider}`}>
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-terracotta opacity-75 animate-ping" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-terracotta" />
        </span>
        <span className={`font-sans text-[10px] uppercase tracking-[0.2em] transition-colors duration-300 ${s.cta}`}>
          {cta}
        </span>
      </span>
    </button>
  );
};
